import React, { useState } from 'react';
import { Text, Stack, Group, Button } from '@mantine/core';
import { Dropzone, FileWithPath } from '@mantine/dropzone';
import UploadForm from '../components/upload/UploadForm';
import api from '../services/api';

const Upload: React.FC = () => {
  const [files, setFiles] = useState<FileWithPath[]>([]);

  const handleFileDrop = (droppedFiles: FileWithPath[]) => {
    setFiles(prev => [...prev, ...droppedFiles]);
  };

  const removeFile = (indexToRemove: number) => {
    setFiles(files.filter((_, index) => index !== indexToRemove));
  };

  const handleUpload = async (formData: FormData) => {
    return await api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
  };

  return (
    <UploadForm
      title="Upload Menu by Photo"
      uploadType="photo"
      fileFieldName="menuImages"
      files={files}
      onFilesChange={setFiles}
      onUpload={handleUpload}
    >
      {/* Photo-specific content */}
      <Dropzone
        onDrop={handleFileDrop}
        accept={{
          'image/*': ['.png', '.jpg', '.jpeg', '.gif'],
          'application/pdf': ['.pdf'],
        }}
        mb="md"
      >
        <Text ta="center" size="lg">
          Drag and drop menu files here, or click to select files
        </Text>
        <Text ta="center" size="sm" c="dimmed" mt={7}>
          Attach as many files as you like, each file should not exceed 5mb
        </Text>
      </Dropzone>

      {files.length > 0 && (
        <Stack mb="md">
          <Text fw={500}>Files to upload:</Text>
          {files.map((file, index) => (
            <Group key={index} justify="space-between" wrap="nowrap">
              <Text size="sm" style={{ wordBreak: 'break-all' }}>
                {file.name}
              </Text>
              <Button
                variant="subtle"
                color="red"
                size="xs"
                onClick={() => removeFile(index)}
              >
                Remove
              </Button>
            </Group>
          ))}
        </Stack>
      )}
    </UploadForm>
  );
};

export default Upload; 